<ui-confirmation-dialog
    #payMultiEPTModal
    *ngIf="payroll && payroll.eptSummariesNonQc.length"
    [header]="'payroll.run.otherRemittancesPay.otherRemittancesOwing'"
    size="medium"
    [primaryButtonLabel]="'continue'"
>
    <app-other-remittances-pay [eptSummaries]="payroll.eptSummariesNonQc" />
    <div class="margin-bottom-4"></div>
</ui-confirmation-dialog>

<div class="ui basic narrow segment" [class.loading]="isLoading">
    <ui-card>
        <app-segment-header
            title="payroll.run.completingPayroll"
            (edit)="openHelp()"
            editLabel="payroll.run.haveAQuestionAboutPayroll"
        ></app-segment-header>

        <p>{{ 'payroll.run.payrollHasBeenConfirmedAndWillBeCompletedShortly' | translate }}</p>

        <br />

        <div class="progress-bar">
            <span class="progress-bar-label">{{ 'payroll.run.generatingEmployeePaystubs' | translate }}</span>
            <span style="float: right">{{ getProgress() }}%</span>
            <mat-progress-bar class="margin-top-1" mode="determinate" [value]="getProgress()"></mat-progress-bar>
        </div>

        <br />

        <ng-container *ngIf="payroll">
            <h4>{{ 'payroll.run.payPeriod' | translate }}</h4>
            {{ payroll.startDate | appDate }} - {{ payroll.endDate | appDate }}
            <h4>{{ 'payroll.run.payDate' | translate }}</h4>
            {{ payroll.chequeDate | appDate }}
            <h4>{{ 'payroll.run.payrollTypeHeader' | translate }}</h4>
            {{
                'payroll.run.payrollType'
                    | translate: { type: payrollType, period: payroll.periodNo, totalPeriods: payroll.totalPeriods }
            }}
            <h4>{{ 'payroll.run.totalPayrollAmount' | translate }}</h4>
            {{ payroll.liability | currency }}
        </ng-container>
    </ui-card>
</div>
